<div class="message-box error" fxFlex fxLayout="row" fxLayoutAlign="space-between center">
  <p>Admin update available, press update when convenient.</p>
  <button class="ml-12" mat-flat-button (click)="updateApp()">UPDATE</button>
</div>
